import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { ConfirmationService, TreeNode } from 'tn-custom-primeng/api';
import {
    ColumnSchemaBase,
    ComponentContextService,
    DataListBase,
    ModelSchema,
    OrganizationService,
    UserV5Service,
} from 'tnx-shared';

@Component({
    selector: 'user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    providers: [ComponentContextService],
})
export class UserComponent extends DataListBase implements OnInit, AfterViewInit {

    searchSchema: any = {};
    searchData: any = {};
    showResetPasswordForm = false;

    rootTreeNode: TreeNode[] = [
        {
            label: '',
            data: '-1',
            expandedIcon: 'fas fa-folder-open',
            collapsedIcon: 'fas fa-folder',
            children: [],
        }];

    isFirstLoad = true;
    rootFilter: any = {};

    selectedTreeNode: any;
    treeLoading = false;
    selectedNodeData: any;

    currentOrgId: any;

    environment: any = {};

    constructor(
        protected _injector: Injector,
        protected _userServiceV5: UserV5Service,
        private _organizationService: OrganizationService,
        private _confirmService: ConfirmationService,
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._userServiceV5;
        this.plusUrl = `FilterByOrg/00000000-0000-0000-0000-000000000000`;
        this.setting.objectName = 'người dùng';

        this.setting.modelSchemas = [
            new ModelSchema({ field: 'userName', name: 'Tài khoản', fullName: 'Tài khoản', description: 'Tài khoản' }),
            new ModelSchema({ field: 'email', name: 'Email', fullName: 'Email', description: 'Email' }),
            new ModelSchema({
                field: 'phoneNumber',
                name: 'Điện thoại',
                fullName: 'Điện thoại',
                description: 'Điện thoại',
            }),
            new ModelSchema({
                field: 'twoFactorEnabled',
                dataType: 'boolean',
                name: '',
                fullName: '',
                description: '',
            }),
            new ModelSchema({
                field: 'lockoutEnabled',
                dataType: 'boolean',
                name: 'Đã khóa',
                fullName: 'Đã khóa',
                description: 'Đã khóa',
            }),
            new ModelSchema({
                field: 'accessFailedCount',
                dataType: 'int',
                name: 'Đăng nhập sai',
                fullName: 'Số lần đăng nhập sai gần nhất',
                description: '',
            }),
            new ModelSchema({
                field: 'isSuperUser',
                dataType: 'boolean',
                name: 'Là quản trị cao nhất',
                fullName: 'Là quản trị cao nhất',
                description: 'Là quản trị cao nhất',
            }),
            new ModelSchema({ field: 'address', name: 'Địa chỉ', fullName: 'Địa chỉ', description: 'Địa chỉ' }),
            new ModelSchema({
                field: 'dOB',
                dataType: 'date',
                name: 'Ngày sinh',
                fullName: 'Ngày sinh',
                description: 'Ngày sinh',
            }),
            new ModelSchema({
                field: 'fullNameNew',
                name: 'Họ và tên',
                fullName: 'Họ và tên',
                description: 'Họ và tên',
            }),
            new ModelSchema({
                field: 'isAdmin',
                dataType: 'boolean',
                name: 'Là quản trị',
                fullName: 'Là quản trị',
                description: 'Là quản trị',
            }),
        ];

        this.setting.cols = [
            new ColumnSchemaBase({ field: 'userName', fullTextSearch: true }),
            new ColumnSchemaBase({ field: 'fullNameNew', fullTextSearch: true }),
            new ColumnSchemaBase({ field: 'email', fullTextSearch: true }),
            new ColumnSchemaBase({ field: 'dOB' }),
            new ColumnSchemaBase({ field: 'isAdmin' }),
            new ColumnSchemaBase({ field: 'isSuperUser' }),
            new ColumnSchemaBase({ field: 'accessFailedCount' }),
            new ColumnSchemaBase({ field: 'lockoutEnabled' }),
        ];

        this.initTree();

        super.ngOnInit();
    }


    deactive(rowData: any) {

        this._confirmService.confirm({
            acceptLabel: this._translateService.instant('CONFIRM.ACCEPT_LABEL'),
            rejectLabel: this._translateService.instant('CONFIRM.REJECT_LABEL'),
            message: 'Bạn có chắc chắn khóa người dùng này?',
            header: 'Xác nhận khóa',
            accept: () => {
                this._userService.lockUser(rowData).then(response => {
                    this._notifierService.showUpdateDataSuccess();
                    this._triggerProcessData();
                }, error => {
                    this._notifierService.showLockUserFailed();
                });
            },
        });
    }

    active(rowData: any) {

        this._confirmService.confirm({
            acceptLabel: this._translateService.instant('CONFIRM.ACCEPT_LABEL'),
            rejectLabel: this._translateService.instant('CONFIRM.REJECT_LABEL'),
            message: 'Bạn có chắc chắn mở khóa người dùng  này?',
            header: 'Xác nhận mở khóa',
            accept: () => {
                this._userService.unlockUser(rowData).then(response => {
                    this._notifierService.showUpdateDataSuccess();
                    this._triggerProcessData();
                }, error => {
                    this._notifierService.showUnlockUserFailed();
                });
            },
        });
    }


    setIsManager(rowData: any, isAdmin: boolean) {
        this._confirmService.confirm({
            acceptLabel: this._translateService.instant('CONFIRM.ACCEPT_LABEL'),
            rejectLabel: this._translateService.instant('CONFIRM.REJECT_LABEL'),
            message: isAdmin ? 'Bạn có chắc chắn xét quyền người dùng này làm quản trị viên?' : 'Bạn có chắc chắn xóa quyền quản trị viên của người dùng này?',
            header: 'Xác nhận mở khóa',
            accept: () => {
                this._userService.markAsAdmin(rowData.id, isAdmin).then(response => {
                    this._notifierService.showUpdateDataSuccess();
                    this._triggerProcessData();
                }, error => {
                    this._notifierService.showUpdateDataFailed();
                });
            },
        });
    }


    async initTree() {
        const rs = await this._organizationService.getOrganizationTree();
        this.rootTreeNode = rs.data;
        this.rootTreeNode[0].expanded = true;
    }

    onNodeExpand(event) {

    }

    async nodeSelect(event) {
        this.currentOrgId = event.node.data;
        this.plusUrl = `FilterByOrg/${this.currentOrgId}`;
        this._triggerProcessData();
    }

    resetPassword(rowData) {
        this.formModel.data = this._commonService.cloneObject(rowData);
        this.formModel.data.passwordHash = '';
        this.beforeAdd();
        this.showResetPasswordForm = true;
    }

    handleCancelResetPasswordForm($event) {
        this.showResetPasswordForm = false;
    }

    handleResetPassword() {
        this.showResetPasswordForm = false;
        this._triggerProcessData();
    }

    /**
     * Reset mật khẩu của các account được chọn
     * Nếu không account nào được chọn thì reset tất cả account
     */
    resetPasswordSelected() {
        const itemSelecteds = this.model.selectedItems;
        if (!itemSelecteds || itemSelecteds.length == 0)
            return this._notifierService.showWarning('Bạn chưa chọn người dùng muốn reset mật khẩu');
        this._notifierService.showConfirm('Bạn có chắc chắn muốn reset mật khẩu những người dùng đã chọn')
            .then(res => {
                if (!res) {
                    return;
                }
                this._userServiceV5.resetPasswordByIds(itemSelecteds.map(item => item.id))
                    .then(res => this.handleResponse(res, 'Reset mật khẩu thành công', f => {

                    }));
            });
    }

    resetPasswordAll() {
        const userRaw = this._environmentService.getUsersHasPermissionResetPassword();
        if (!userRaw) {
            return this._notifierService.showWarning('Bạn không có quyền thực hiện chức năng này');
        }
        const users = userRaw.split(',');
        const userName = this._userServiceV5.getCurrentUser().userName;
        if (users.indexOf(userName) == -1) {
            return this._notifierService.showWarning('Bạn không có quyền thực hiện chức năng này');
        }
        this._notifierService.showConfirm('Bạn có chắc chắn muốn reset mật khẩu của tất cả người dùng')
            .then(res => {
                if (!res) {
                    return;
                }
                this._userServiceV5.resetPasswordAll().then(res => this.handleResponse(res, 'Reset mật khẩu thành công', f => {}));
            });
    }
}

